import { computed, ref } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'
import useForm from '@/compositions/useForm'

import { isNotDecimal, isPositive, required } from '@/utils/validations'

import { occupationType } from '@/constants/occupations'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import TimePicker from '@/components/TimePicker/TimePicker.vue'
import useDrivers from '@/compositions/useDrivers'


export default {
  components: {
    DatePicker, TimePicker,
  },

  setup(props, context) {
    const { $store } = context.root
    const { emit } = context

    const { id } = context.root.$route.params

    const { loadingDrivers, drivers } = useDrivers(context)
    const validationWarning = ref([])

    const {
      validate, $errors, formData, getData, reset,
    } = useForm({
      fields: {
        machineHours: { default: '', validations: { isNotDecimal, isPositive, required } },
        orderId: { default: '', validations: { required } },
        date: { default: '', validations: { required } },
        driverId: { default: '', validations: { required: false } },
      },
    })

    const orderIds = computed(() => $store.getters['auth/orderIds'])

    const { loading, makeRequest } = useRequest({
      context,
      successMessage: 'Моточасы добавлены!',
      request: () => $store.dispatch('drivers/addMachineHours', {
        id,
        data: {
          orderId: getData().orderId,
          date: getData().date,
          hours: getData().machineHours,
          driverId: Number(id),
        },
      }),
    })

    const submit = async () => {
      if (!validate()) return
      await makeRequest()
      emit('update')
      reset()
    }

    return {
      loadingDrivers,
      drivers,
      orderIds,
      formData,
      loading,
      $errors,
      validationWarning,
      submit,

      types: Object.keys(occupationType).map(key => ({
        text: occupationType[key].label,
        value: occupationType[key].value,
      })),
    }
  },
}
